import React, { Component } from 'react'
import { Link, Navigate, useNavigate } from "react-router-dom";

import CustomModal from "../Bar/CustomModal";
import Pagination from "../Bar/Pagination";
import API from '../../config/api';
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';
import "react-toastify/dist/ReactToastify.css";

export class ClassIndex extends Component {

  constructor(props) {
    super(props)
    
    // this.getAllCategories = this.getAllCategories.bind(this);
    this.state = {
      data: null,
      s: '',
      limit: 100,
      page: 1,
      total: 0,
      all_class: [],
      image_url: ""
    }
  }

  componentDidMount() {
    this.getParam("success")
  }

  UNSAFE_componentWillMount() {
    this.getAllClass();
    this.getImageLink();
  }

  getImageLink() {
    let url = API.getImage();
    this.state.image_url = url
    this.setState({})
  }

  getParam(name) {
    let success = window.location.search.split(`${name}=`)[1]
    if(success){
      toast.success("Your action is successful", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
   }
  }

  getAllClass = async () => {
    try {
      let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
      let results = await API.getAllClass(query);
      let data = results.data;
      
      this.setState({ all_class : data.class, total: data.total });

    } catch (error) {
      console.log(error)
    }
  }

  onSearch = async (event) => {
    event.preventDefault();
    let value = event.target.value;
    try {
      let query = `page=${this.state.page}&s=${value}&limit=${this.state.limit}`
      let results = await API.getAllClass(query);
      
      let data = results.data;
      
      this.setState({ all_class : data.class, total: data.total });

    } catch (error) {
      console.log(error)
    }
  }

  onPaginationPress = (page) => {
    this.state.page = page;
    // this.setState({ page : page})
    this.getAllCategories();
    this.setState({})
  }

  deleteClass = async (event) => {
    event.preventDefault();
    let data = {
      id : this.state.data.id
    }
    try {
      let results = await API.postDeleteClass(data);
      
      if (results.result){
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        this.getAllClass();
      }

    } catch (error) {
      console.log(error)
    }
  }

  linkToNewPage= async (event, id) => {
    event.preventDefault();


    let element = document.getElementById(`linktonewpage${id}`);
    element.click();
  }

  render() {
    return (
      <div className="col-12 ">
        {/* <ToastContainer /> */}
          <div className="card card-body card-hover-shadow p-40">
            <h4 className="card-title"><strong>Class Lists</strong></h4>

            <div className="card-body">

            <div className="flexbox mb-20">
                <div className="lookup">
                  <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                </div>

                <div className="btn-toolbar">
                  <div className="btn-group btn-group-sm">
                    {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                    {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                    <Link to="/classnew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link>
                    {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                  </div>

                  {/* <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                    <button className="btn dropdown-toggle" data-toggle="dropdown">Export</button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a className="dropdown-item" href="/">CSV</a>
                      <a className="dropdown-item" href="/">SQL</a>
                      <a className="dropdown-item" href="/">PDF</a>
                      <a className="dropdown-item" href="/">Text</a>
                    </div>
                  </div> */}
                </div>
              </div>
            <div>
          </div>

              <table className="table table-hover table-has-action">
                <thead>
                  <tr>
                    <th><h6>#</h6></th>
                    {/* <th> <h6>Thumbnail</h6> </th> */}
                    <th> <h6>Name</h6> </th>
                    <th> <h6>Level</h6> </th>
                    <th> <h6>Amount</h6> </th>
                    <th> <h6>Created date</h6></th>
                    <th class="text-center w-150px"><h6>Actions</h6></th>
                  </tr>
                </thead>
                <tbody>
                {
                  this.state.all_class
                  .map((clas, index)=> {
                  let amount_student = JSON.parse(clas.user_id);  
                  return <tr>
                    {/* <tr onClick={(event) => this.linkToNewPage(event, clas.id)}></tr> */}
                      <th onClick={(event) => this.linkToNewPage(event, clas.id)} scope="row"><b>{( (this.state.page - 1) * 10) + (index + 1)}</b></th>
                      {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={category.thumbnail_url} alt="video thumbnail" /></td> */}
                      {/* <td>
                        <div class="media">
                          <img class="avatar" src={folder.thumbnail_url ? folder.thumbnail_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                          <img class="avatar" src={category.thumbnail_url ? category.thumbnail_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                          <div class="media-body">
                          </div>
                        </div>
                      </td> */}
                      <td onClick={(event) => this.linkToNewPage(event, clas.id)}><strong>{clas.name}</strong></td>
                      <td onClick={(event) => this.linkToNewPage(event, clas.id)}><strong>{clas.level}</strong></td>
                      <td onClick={(event) => this.linkToNewPage(event, clas.id)}><strong>{amount_student.length} <i class="fa fa-users"> </i></strong></td>
                      {/* <td><strong>{clas.code}</strong></td> */}
                      <td onClick={(event) => this.linkToNewPage(event, clas.id)}>{moment(clas.created_at).format("DD-MMM-YYYY")}</td>
                      <td className="text-right table-actions">
                        <Link title='View' class="btn btn-square btn-round btn-primary" id={`linktonewpage${clas.id}`} to={`/classview?id=${clas.id}`}><i class="fa fa-eye"></i></Link>
                        <span>&nbsp;</span><Link title='Edit' class="btn btn-square btn-round btn-info" to={`/classedit?id=${clas.id}`}><i class="ti-pencil"></i></Link>
                        <span>&nbsp;</span><button title='Delete' class="btn btn-square btn-round btn-danger" data-toggle="modal" data-target="#modal-center" onClick={(event) => {
                            // event.preventDefault();
                            this.setState({data: clas})
                          }}><i class="fa fa-trash"></i></button>

                        {/* <Link className="table-action hover-primary" title="View" to={`/categoryview?id=${category.id}`}><i className="fa fa-eye"></i></Link>
                        <Link className="table-action hover-primary" title="Edit" to={`/categoryedit?id=${category.id}`}><i class="ti-pencil"></i></Link> */}
                      
                        {/* <i className="ti-trash table-action hover-danger" data-toggle="modal" data-target="#modal-center" title="Delete" onClick={() => this.setState({data: category})}></i>  */}

                        {/* <div className="dropdown table-action">
                          <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                          <div className="dropdown-menu dropdown-menu-right">
                            <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                            <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                            <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                          </div>
                        </div> */}
                      </td>
                    </tr>
                  })
                }
                </tbody>
              </table>
              {/* <Pagination 
                onPaginationPress = {this.onPaginationPress}
                totalPageLength = {this.state.total}
                selectPage = {this.state.page}
              /> */}
            </div>
          </div>
          {
              this.state.data &&
              <CustomModal 
                data={ this.state.data }  
                title="Do you really want to delete this class?"
                deleteQuiz = {this.deleteClass}
              />
           }
        </div>
    )
  }
}

const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <ClassIndex navigate={navigate} />;
};

export default MyComponentWithNavigate;